import { computed, readonly, ref, watch } from 'vue'
import { AppError } from '../../error-handling/AppError'

export enum StartupState {
  /** Not yet started */
  NotStarted = 'NotStarted',
  /** Loading data needed for startup (pre-startup) */
  Initializing = 'Initializing',
  /** All data required for startup of application have been loaded from cache and updated from backend if needed */
  ReadyForStartup = 'ReadyForStartup',
  /** Something went wrong with the startup-process */
  Error = 'Error'
}

export function useStartupState() {
  const startupState = ref<StartupState[]>([StartupState.NotStarted])

  const startupStateError = ref<AppError | undefined>()

  function setStartupStateError(error: AppError) {
    startupStateError.value = error
  }

  function setStartupState(state: StartupState) {
    if (startupState.value.includes(state)) {
      console.error(`Startup state ${state} already set.`)
      return
    }
    startupState.value.push(state)
  }

  /** Returns true if startupState conditions are met. */
  const appReady = computed(() =>
    startupState.value.includes(StartupState.ReadyForStartup)
  )

  return {
    startupState,
    startupStateError: readonly(startupStateError),
    setStartupState,
    setStartupStateError,
    appReady
  }
}
